import {
  type BettingInsightsConfigFactoryOptions,
  type EventOverviewIndex,
  type EventOverviewResult,
} from '~/configuration/types';
import { type BettingInsightsUIConfig, createBettingInsightsUIConfig } from '~/configuration/ui/BettingInsightsUI';
import { type RequestContext } from '~/vendor/cx-web/domain-types';

export function createEventOverviewUIConfig(
  requestContext: RequestContext,
  _options: BettingInsightsConfigFactoryOptions = {},
  tags: string[],
) {
  const uiConfig: BettingInsightsUIConfig<EventOverviewIndex, EventOverviewResult> = {
    card: {
      styles: {},
      table: {
        body: {
          render(_context, { content }) {
            return (
              <div className="event-overview-stats">
                <div>Subevent ID: {content.subeventId}</div>
                <div>Event: {content.eventDisplayName}</div>
              </div>
            );
          },
        },
        footer: {
          render(_context) {
            return null;
          },
        },
        getContent(_context, { result }) {
          return [result];
        },
        headings: {
          row: 1,
          content: [],
        },
        main: {
          render(_context) {
            return null;
          },
        },
        cells: [],
      },
      title: {
        format: '{eventDisplayName} | {subeventName}',
      },
      wrapper(_context, { children }) {
        return <div>{children}</div>;
      },
    },
    initialUiState(_context) {
      return {};
    },
    refinements: {
      clearAll: {
        excludedAttributes: [],
      },
      components: [],
    },
    results: {
      categories() {
        return {
          attribute: 'subeventId',
          labels: {},
          order: {
            start: [],
            end: [],
          },
        };
      },
      labelledBy: '#event-overview-title',
      propsName: 'eventStats',
    },
    search: {
      render(_context) {
        return null;
      },
    },
    sorting: {
      canSort() {
        return false;
      },
    },
  };

  return {
    ui: createBettingInsightsUIConfig(requestContext, uiConfig, tags),
  };
}
